import { Icon } from "@chakra-ui/react"

interface CatProps {
  className?: string
  color?: string
  width?: string
  maxWidth?: string
  alt?: string
  height?: string
}
const ErrorIllustration: React.FC<CatProps> = ({
  alt = "Error 404 Robot Illustration",
  className,
  height = "100%",
  maxWidth = "100%",
  width = "100%",
}) => {
  return (
    <Icon
      as={"svg"}
      className={className}
      fill="none"
      height={height}
      style={{ maxWidth: maxWidth }}
      viewBox="0 0 1753 1394"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{alt}</title>
      <path
        d="M1749.82 1316.79C1749.82 1359.18 1358.27 1393.53 875.268 1393.53C392.268 1393.53 0.71795 1359.18 0.71795 1316.79C0.71795 1274.4 392.268 1240.04 875.268 1240.04C1358.27 1240.04 1749.82 1274.4 1749.82 1316.79Z"
        fill="var(--gil-colors-bg)"
      />
      <path
        d="M1532.87 1107.28C1532.87 1125.62 1517.86 1140.62 1499.53 1140.62H251.011C232.682 1140.62 217.678 1125.62 217.678 1107.28V354.943C217.678 336.61 232.682 321.61 251.011 321.61H1499.53C1517.86 321.61 1532.87 336.61 1532.87 354.943V1107.28Z"
        fill="#6680E1"
      />
      <path
        d="M254.801 361.779H1495.74V1100.45H254.801V361.779Z"
        fill="#CDDCF8"
      />
      <path d="M671.1 1140.62H1079.44V1242.88H671.1V1140.62Z" fill="#7B98F0" />
      <path
        d="M1274.88 1301.6C1200.2 1241.31 1049.29 1200.09 875.272 1200.09C701.247 1200.09 550.339 1241.31 475.664 1301.6H1274.88Z"
        fill="#6680E1"
      />
      <path
        d="M475.662 1312.02H1242.28C1252.69 1312.02 1263.13 1312.27 1273.53 1312.02C1273.98 1312 1274.43 1312.02 1274.88 1312.02C1288.28 1312.02 1288.31 1291.18 1274.88 1291.18H508.258C497.854 1291.18 487.412 1290.93 477.008 1291.18C476.562 1291.19 476.108 1291.18 475.662 1291.18C462.258 1291.18 462.233 1312.02 475.662 1312.02Z"
        fill="#7B98F0"
      />
      <path
        d="M322.579 413.163H1427.96V1052.26H322.579V413.163Z"
        fill="white"
      />
      <path
        d="M322.579 413.167H1427.96V474.75H322.579V413.167Z"
        fill="#E1E7FF"
      />
      <path
        d="M376.309 445.375C376.309 453.158 369.996 459.466 362.221 459.466C354.434 459.466 348.125 453.158 348.125 445.375C348.125 437.591 354.434 431.287 362.221 431.287C369.996 431.287 376.309 437.591 376.309 445.375Z"
        fill="#FF735E"
      />
      <path
        d="M423.762 445.375C423.762 453.158 417.453 459.466 409.674 459.466C401.887 459.466 395.578 453.158 395.578 445.375C395.578 437.591 401.887 431.287 409.674 431.287C417.453 431.287 423.762 437.591 423.762 445.375Z"
        fill="#FFAD36"
      />
      <path
        d="M471.217 445.377C471.217 453.16 464.908 459.469 457.125 459.469C449.342 459.469 443.033 453.16 443.033 445.377C443.033 437.594 449.342 431.285 457.125 431.285C464.908 431.285 471.217 437.594 471.217 445.377Z"
        fill="#6680E1"
      />
      <path
        d="M1265.85 745.066C1265.85 783.157 1233.11 814.316 1193.11 814.316H578.119C538.11 814.316 505.377 783.157 505.377 745.066C505.377 706.978 538.11 675.816 578.119 675.816H1193.11C1233.11 675.816 1265.85 706.978 1265.85 745.066Z"
        fill="#E1E7FF"
      />
      <path
        d="M592.394 752.968C588.069 748.943 585.573 743.48 585.361 737.576C585.148 731.672 587.248 726.039 591.269 721.714C595.294 717.389 600.761 714.889 606.665 714.68C612.565 714.468 618.198 716.568 622.523 720.589C626.848 724.614 629.344 730.08 629.557 735.984C629.769 741.889 627.669 747.518 623.648 751.843C619.623 756.168 614.157 758.664 608.253 758.876C602.353 759.093 596.719 756.993 592.394 752.968ZM657.498 777.709L632.261 754.23C636.073 748.839 638.04 742.397 637.794 735.689C637.507 727.58 634.073 720.076 628.14 714.555C622.203 709.03 614.469 706.151 606.369 706.443C598.265 706.73 590.757 710.164 585.236 716.097C579.711 722.034 576.832 729.768 577.119 737.872C577.411 745.972 580.844 753.48 586.778 759.001C592.715 764.526 600.448 767.409 608.548 767.118C615.261 766.876 621.544 764.451 626.648 760.264L651.886 783.747L657.498 777.709Z"
        fill="#6680E1"
      />
      <path
        d="M774.072 743.883C774.072 747.829 770.876 751.021 766.939 751.021C762.997 751.021 759.806 747.829 759.806 743.883C759.806 739.946 762.997 736.75 766.939 736.75C770.876 736.75 774.072 739.946 774.072 743.883Z"
        fill="#B2C4F4"
      />
      <path
        d="M857.402 743.883C857.402 747.829 854.207 751.021 850.269 751.021C846.327 751.021 843.136 747.829 843.136 743.883C843.136 739.946 846.327 736.75 850.269 736.75C854.207 736.75 857.402 739.946 857.402 743.883Z"
        fill="#B2C4F4"
      />
      <path
        d="M940.736 743.883C940.736 747.829 937.54 751.021 933.603 751.021C929.661 751.021 926.47 747.829 926.47 743.883C926.47 739.946 929.661 736.75 933.603 736.75C937.54 736.75 940.736 739.946 940.736 743.883Z"
        fill="#B2C4F4"
      />
      <path
        d="M1024.07 743.883C1024.07 747.829 1020.87 751.021 1016.94 751.021C1013 751.021 1009.8 747.829 1009.8 743.883C1009.8 739.946 1013 736.75 1016.94 736.75C1020.87 736.75 1024.07 739.946 1024.07 743.883Z"
        fill="#B2C4F4"
      />
      <path
        d="M1123.86 163.696H1674.06V769.021H1123.86V163.696Z"
        fill="#F4F9FF"
      />
      <path
        d="M1123.86 163.692H1674.06V231.929H1123.86V163.692Z"
        fill="#E1E7FF"
      />
      <path
        d="M1183.4 199.385C1183.4 208.01 1176.41 215.001 1167.79 215.001C1159.16 215.001 1152.17 208.01 1152.17 199.385C1152.17 190.764 1159.16 183.768 1167.79 183.768C1176.41 183.768 1183.4 190.764 1183.4 199.385Z"
        fill="#FF735E"
      />
      <path
        d="M1235.98 199.387C1235.98 208.008 1228.99 214.999 1220.36 214.999C1211.75 214.999 1204.75 208.008 1204.75 199.387C1204.75 190.766 1211.75 183.766 1220.36 183.766C1228.99 183.766 1235.98 190.766 1235.98 199.387Z"
        fill="#FFAD36"
      />
      <path
        d="M1288.56 199.385C1288.56 208.01 1281.57 215.001 1272.95 215.001C1264.32 215.001 1257.33 208.01 1257.33 199.385C1257.33 190.764 1264.32 183.768 1272.95 183.768C1281.57 183.768 1288.56 190.764 1288.56 199.385Z"
        fill="#6680E1"
      />
      <path
        d="M1489.79 565.876L1512.51 543.152L1716.18 746.822L1693.46 769.547L1489.79 565.876Z"
        fill="#FF735E"
      />
      <path
        d="M1476.82 572.939L1519.57 530.186L1579.17 589.78L1536.42 632.533L1476.82 572.939Z"
        fill="#6680E1"
      />
      <g opacity="0.2">
        <path
          d="M1501.15 554.518C1447.89 607.787 1361.2 607.793 1307.93 554.515C1254.66 501.244 1254.66 414.561 1307.93 361.293C1361.2 308.021 1447.88 308.018 1501.15 361.29C1554.43 414.567 1554.43 501.247 1501.15 554.518Z"
          fill="#F4F9FF"
        />
      </g>
      <path
        d="M1317.68 371.046C1269.79 418.942 1269.79 496.867 1317.68 544.759C1365.57 592.654 1443.5 592.659 1491.4 544.759C1539.3 496.867 1539.3 418.942 1491.4 371.046C1443.5 323.154 1365.58 323.15 1317.68 371.046ZM1514.12 567.488C1453.7 627.904 1355.38 627.909 1294.96 567.488C1234.54 507.063 1234.54 408.742 1294.96 348.321C1355.38 287.9 1453.7 287.896 1514.12 348.321C1574.55 408.746 1574.55 507.063 1514.12 567.488Z"
        fill="#FF735E"
      />
      <path
        d="M1472.5 409.96L1452.49 389.948L1404.54 437.894L1356.6 389.948L1336.58 409.96L1384.53 457.902L1336.58 505.848L1356.6 525.86L1404.54 477.919L1452.49 525.86L1472.5 505.848L1424.55 457.902L1472.5 409.96Z"
        fill="#FFAD36"
      />
      <path
        d="M527.761 863.059H278.873V1312.69H662.765V992.392L527.761 863.059Z"
        fill="#FF735E"
      />
      <path
        d="M527.76 863.059L662.764 992.392H527.76V863.059Z"
        fill="#FFAFA7"
      />
      <path
        d="M429.875 1035.85C429.875 1049.35 422.033 1060.29 412.362 1060.29C402.692 1060.29 394.85 1049.35 394.85 1035.85C394.85 1022.36 402.692 1011.42 412.362 1011.42C422.033 1011.42 429.875 1022.36 429.875 1035.85Z"
        fill="white"
      />
      <path
        d="M546.301 1035.85C546.301 1049.35 538.459 1060.29 528.788 1060.29C519.117 1060.29 511.276 1049.35 511.276 1035.85C511.276 1022.36 519.117 1011.42 528.788 1011.42C538.459 1011.42 546.301 1022.36 546.301 1035.85Z"
        fill="white"
      />
      <path
        d="M421.868 1109.21C429.155 1101.23 439.293 1094.96 449.376 1091.32C474.901 1082.12 499.572 1091.73 519.018 1109.21C524.21 1113.88 531.926 1106.21 526.71 1101.52C505.155 1082.15 477.197 1070.77 448.526 1080.13C435.951 1084.25 423.185 1091.66 414.18 1101.52C409.468 1106.69 417.139 1114.39 421.868 1109.21Z"
        fill="white"
      />
      <path
        d="M396.622 104.925H116.663C99.9633 104.925 86.3008 118.587 86.3008 135.287V331.662C86.3008 348.362 99.9633 362.029 116.663 362.029H215.03L256.642 412.717L298.255 362.029H396.622C413.322 362.029 426.984 348.362 426.984 331.662V135.287C426.984 118.587 413.322 104.925 396.622 104.925Z"
        fill="#FFAD36"
      />
      <path
        d="M256.642 309.348C239.046 309.348 222.854 303.26 210.025 293.098L315.617 187.502C325.779 200.331 331.871 216.523 331.871 234.118C331.871 275.602 298.125 309.348 256.642 309.348ZM256.642 158.893C274.238 158.893 290.429 164.985 303.259 175.143L197.667 280.735C187.504 267.91 181.413 251.714 181.413 234.118C181.413 192.639 215.163 158.893 256.642 158.893ZM256.642 141.41C205.521 141.41 163.934 182.998 163.934 234.118C163.934 285.239 205.521 326.831 256.642 326.831C307.763 326.831 349.35 285.239 349.35 234.118C349.35 182.998 307.763 141.41 256.642 141.41Z"
        fill="white"
      />
      <path
        d="M1441.58 894.533L1209.38 892.999L1206.61 1312.47L1564.76 1314.83L1566.73 1016.02L1441.58 894.533Z"
        fill="#CDDCF8"
      />
      <path
        d="M1441.58 894.533L1566.73 1016.02L1440.79 1015.19L1441.58 894.533Z"
        fill="#E0ECFD"
      />
      <path
        d="M1463.03 1050.9L1440.91 1028.48L1387.22 1081.47L1334.23 1027.78L1311.82 1049.9L1364.81 1103.59L1311.12 1156.57L1333.24 1178.98L1386.92 1126L1439.92 1179.69L1462.32 1157.58L1409.34 1103.88L1463.03 1050.9Z"
        fill="#ECF4FF"
      />
      <path
        d="M270.858 570.979L131.895 501.329L6.07031 752.371L220.408 859.8L310.041 680.971L270.858 570.979Z"
        fill="#CDDCF8"
      />
      <path
        d="M270.856 570.979L310.039 680.971L234.66 643.191L270.856 570.979Z"
        fill="#E0ECFD"
      />
      <path
        d="M237.453 671.213L230.807 651.209L182.882 667.134L166.961 619.213L146.957 625.855L162.882 673.776L114.961 689.701L121.603 709.701L169.528 693.78L185.453 741.701L205.453 735.055L189.532 687.134L237.453 671.213Z"
        fill="#ECF4FF"
      />
      <path
        d="M790.65 104.986L679.434 141.178L744.813 342.098L916.359 286.278L869.788 143.148L790.65 104.986Z"
        fill="#CDDCF8"
      />
      <path
        d="M790.65 104.986L869.788 143.148L809.459 162.782L790.65 104.986Z"
        fill="#E0ECFD"
      />
      <path
        d="M825.769 176.309L811.635 169.114L794.398 202.976L760.535 185.743L753.344 199.876L787.206 217.109L769.969 250.972L784.102 258.168L801.34 224.305L835.202 241.539L842.394 227.405L808.531 210.172L825.769 176.309Z"
        fill="#ECF4FF"
      />
      <path
        d="M1042.95 143.515C1021.64 143.44 1004.43 126.103 1004.5 104.79C1004.57 83.4776 1021.9 66.2609 1043.22 66.3359C1064.53 66.4068 1081.75 83.7443 1081.68 105.057C1081.6 126.369 1064.27 143.59 1042.95 143.515ZM1134 85.7109L1124.25 85.6776C1122.22 77.0693 1118.86 68.9943 1114.39 61.6443L1121.3 54.7693C1126.7 49.4109 1126.73 40.6068 1121.37 35.2109L1113.34 27.1234C1107.98 21.7276 1099.18 21.6984 1093.78 27.0568L1086.86 33.9276C1079.54 29.4068 1071.49 25.9859 1062.9 23.8943L1062.93 14.1526C1062.96 6.54428 1056.75 0.298442 1049.15 0.273442L1037.75 0.235942C1030.15 0.206776 1023.9 6.41094 1023.87 14.0193L1023.84 23.7568C1015.23 25.7943 1007.15 29.1568 999.805 33.6276L992.934 26.7068C987.572 21.3109 978.772 21.2818 973.376 26.6401L965.284 34.6693C959.888 40.0318 959.859 48.8318 965.222 54.2318L972.092 61.1484C967.567 68.4693 964.151 76.5193 962.055 85.1151L952.317 85.0818C944.709 85.0568 938.463 91.2568 938.438 98.8651L938.397 110.261C938.372 117.869 944.576 124.115 952.18 124.14L961.922 124.173C963.955 132.782 967.322 140.857 971.792 148.207L964.872 155.078C959.476 160.44 959.442 169.24 964.805 174.64L972.834 182.723C978.192 188.123 986.997 188.153 992.392 182.794L999.313 175.919C1006.63 180.444 1014.68 183.861 1023.28 185.957L1023.25 195.694C1023.22 203.303 1029.42 209.548 1037.03 209.573L1048.42 209.615C1056.03 209.64 1062.28 203.436 1062.3 195.832L1062.33 186.09C1070.95 184.057 1079.02 180.694 1086.37 176.223L1093.24 183.14C1098.6 188.54 1107.4 188.569 1112.8 183.207L1120.89 175.178C1126.28 169.815 1126.32 161.015 1120.95 155.619L1114.08 148.698C1118.6 141.378 1122.03 133.328 1124.12 124.736L1133.85 124.765C1141.47 124.794 1147.71 118.59 1147.73 110.982L1147.78 99.5901C1147.8 91.9818 1141.6 85.7359 1134 85.7109Z"
        fill="#FF735E"
      />
      <path
        d="M1042.97 139.117C1024.09 139.05 1008.83 123.692 1008.9 104.808C1008.96 85.921 1024.32 70.6668 1043.21 70.7335C1062.09 70.8001 1077.35 86.1585 1077.28 105.042C1077.22 123.925 1061.85 139.183 1042.97 139.117ZM1043.28 49.8668C1012.87 49.7626 988.134 74.3251 988.026 104.733C987.926 135.142 1012.49 159.879 1042.9 159.983C1073.3 160.088 1098.04 135.525 1098.15 105.117C1098.25 74.7085 1073.69 49.971 1043.28 49.8668Z"
        fill="#FFAD36"
      />
      <path
        d="M549.73 1232.88V1184.74H570.819C574.346 1184.74 577.397 1185.33 579.974 1186.5C582.596 1187.68 584.607 1189.35 586.009 1191.52C587.41 1193.64 588.111 1196.18 588.111 1199.11C588.111 1201.33 587.636 1203.3 586.687 1205.01C585.783 1206.73 584.517 1208.13 582.89 1209.22C581.307 1210.3 579.476 1210.98 577.397 1211.25L577.194 1210.64C580.403 1210.64 582.844 1211.34 584.517 1212.74C586.19 1214.1 587.139 1216.2 587.365 1219.05L588.586 1232.88H578.075L577.194 1220.68C577.058 1218.82 576.47 1217.47 575.43 1216.61C574.436 1215.71 572.718 1215.25 570.277 1215.25H560.038V1232.88H549.73ZM560.038 1206.64H569.667C572.153 1206.64 574.074 1206.08 575.43 1204.95C576.832 1203.77 577.533 1202.12 577.533 1200C577.533 1197.83 576.832 1196.2 575.43 1195.11C574.029 1193.98 571.995 1193.42 569.328 1193.42H560.038V1206.64Z"
        fill="white"
      />
      <path
        d="M519.437 1233.97C514.555 1233.97 510.35 1232.95 506.824 1230.92C503.343 1228.88 500.654 1225.99 498.755 1222.24C496.901 1218.49 495.975 1214.03 495.975 1208.88C495.975 1203.73 496.901 1199.27 498.755 1195.52C500.654 1191.72 503.343 1188.81 506.824 1186.77C510.35 1184.69 514.555 1183.65 519.437 1183.65C524.319 1183.65 528.501 1184.69 531.982 1186.77C535.508 1188.81 538.198 1191.72 540.051 1195.52C541.95 1199.27 542.899 1203.73 542.899 1208.88C542.899 1214.03 541.95 1218.49 540.051 1222.24C538.198 1225.99 535.508 1228.88 531.982 1230.92C528.501 1232.95 524.319 1233.97 519.437 1233.97ZM519.369 1225.29C522.081 1225.29 524.387 1224.66 526.286 1223.39C528.23 1222.08 529.699 1220.2 530.693 1217.76C531.733 1215.32 532.253 1212.36 532.253 1208.88C532.253 1205.4 531.733 1202.44 530.693 1200C529.699 1197.51 528.23 1195.61 526.286 1194.3C524.387 1192.99 522.081 1192.33 519.369 1192.33C516.702 1192.33 514.419 1192.99 512.52 1194.3C510.622 1195.61 509.152 1197.51 508.113 1200C507.118 1202.44 506.621 1205.4 506.621 1208.88C506.621 1212.36 507.118 1215.32 508.113 1217.76C509.152 1220.2 510.622 1222.08 512.52 1223.39C514.464 1224.66 516.747 1225.29 519.369 1225.29Z"
        fill="white"
      />
      <path
        d="M451.855 1232.88V1184.74H472.944C476.471 1184.74 479.522 1185.33 482.099 1186.5C484.721 1187.68 486.732 1189.35 488.134 1191.52C489.535 1193.64 490.236 1196.18 490.236 1199.11C490.236 1201.33 489.761 1203.3 488.812 1205.01C487.908 1206.73 486.642 1208.13 485.015 1209.22C483.432 1210.3 481.601 1210.98 479.522 1211.25L479.319 1210.64C482.528 1210.64 484.969 1211.34 486.642 1212.74C488.315 1214.1 489.264 1216.2 489.49 1219.05L490.711 1232.88H480.2L479.319 1220.68C479.183 1218.82 478.595 1217.47 477.555 1216.61C476.561 1215.71 474.843 1215.25 472.402 1215.25H462.163V1232.88H451.855ZM462.163 1206.64H471.792C474.278 1206.64 476.199 1206.08 477.555 1204.95C478.957 1203.77 479.658 1202.12 479.658 1200C479.658 1197.83 478.957 1196.2 477.555 1195.11C476.154 1193.98 474.12 1193.42 471.453 1193.42H462.163V1206.64Z"
        fill="white"
      />
      <path
        d="M404.574 1232.88V1184.74H425.663C429.189 1184.74 432.241 1185.33 434.817 1186.5C437.439 1187.68 439.451 1189.35 440.853 1191.52C442.254 1193.64 442.955 1196.18 442.955 1199.11C442.955 1201.33 442.48 1203.3 441.531 1205.01C440.627 1206.73 439.361 1208.13 437.733 1209.22C436.151 1210.3 434.32 1210.98 432.241 1211.25L432.037 1210.64C435.247 1210.64 437.688 1211.34 439.361 1212.74C441.033 1214.1 441.983 1216.2 442.209 1219.05L443.429 1232.88H432.919L432.037 1220.68C431.902 1218.82 431.314 1217.47 430.274 1216.61C429.28 1215.71 427.562 1215.25 425.121 1215.25H414.881V1232.88H404.574ZM414.881 1206.64H424.51C426.997 1206.64 428.918 1206.08 430.274 1204.95C431.676 1203.77 432.376 1202.12 432.376 1200C432.376 1197.83 431.676 1196.2 430.274 1195.11C428.873 1193.98 426.839 1193.42 424.171 1193.42H414.881V1206.64Z"
        fill="white"
      />
      <path
        d="M362.59 1232.88V1184.74H396.088V1193.42H372.897V1204.47H395.274V1213.02H372.897V1224.2H396.63V1232.88H362.59Z"
        fill="white"
      />
    </Icon>
  )
}
export default ErrorIllustration
